import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ActivitySessionTable from '@activities/components/tables/activity-session-table/activity-session-table.vue';

@Component({
  name: 'bpc-activity-sessions',
  components: {
    'bpc-activity-session-table': ActivitySessionTable,
  },
})
export default class ActivitySession extends Vue {
  // DATA
  // data to manage the activitySession forms
  sessionFormConfigName: string = 'default';
  sessionEditFormConfigName: string = 'edit';
  displayConfigName: string = 'table';
  filterConfigName: string = 'default';
  tableKey: number = 1;

  //  COMPUTED
  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  // LIFECYCLE
  // created() {}
  mounted() {
    this.setSessionFormConfig();
  }
  // updated() {}
  // destroyed() {}

  // METHODS
  setSessionFormConfig() {
    if (this.tenantType === 'club') {
      this.sessionFormConfigName = 'create-from-management-for-clubs';
      this.sessionEditFormConfigName = 'edit-from-management-for-clubs';
      //NOTE: if the user only has own permission, the form config is different.
      if (
        !this.$authorizationService.hasPermission('manage_activity_sessions') &&
        this.$authorizationService.hasPermission('manage_own_activity_sessions')
      ) {
        this.sessionFormConfigName = 'create-from-management-for-clubs-hidden-responsibles';
        this.sessionEditFormConfigName = 'edit-from-management-for-clubs-disabled-responsibles';
      }
    } else {
      //NOTE: if the user only has own permission, the form config is different.
      if (
        !this.$authorizationService.hasPermission('manage_activity_sessions') &&
        this.$authorizationService.hasPermission('manage_own_activity_sessions')
      ) {
        this.sessionFormConfigName = 'default-hidden-responsibles';
        this.sessionEditFormConfigName = 'edit-disabled-responsibles';
      }
    }
  }

  onLoadPastSessions() {
    this.displayConfigName = 'past-sessions';
    this.filterConfigName = 'past-sessions';
    this.tableKey++;
  }
  onLoadUpcomingSessions() {
    this.displayConfigName = 'upcoming-sessions';
    this.filterConfigName = 'upcoming-sessions';
    this.tableKey++;
  }
  onLoadDefaultSessions() {
    if (this.tenantType == 'club') {
      this.displayConfigName = 'table';
      this.filterConfigName = 'default-for-club';
    } else {
      this.displayConfigName = 'table';
      this.filterConfigName = 'default';
    }
    this.tableKey++;
  }
}
